import axios from 'axios';
import { getWithRetry, WRITE_TIMEOUT_MS } from '../../misc/requests.js';
const API_URL = process.env.VUE_APP_API_URL + '/cleverreach';
const state = {
    isSubscribed: null,
};

const getters = {
    isSubscribed: (state) => state.isSubscribed,
};

const actions = {
    async createAccount (_, data) {
        return await axios.post(`${API_URL}/create-account/${data.bookingId}`, data, { timeout: WRITE_TIMEOUT_MS });
        
    },
    async resentActivation (_, data) {
        await axios.post(`${API_URL}/resend-activation/${data.bookingId}`, data);
    },
    async checkMail({commit}, { bookingId, signal }) {
        commit('setIsSubscribed', null);
        try {
            await getWithRetry(`${API_URL}/check-mail/${bookingId}`, signal);
            commit('setIsSubscribed', true);
        } catch(err) {
            if(err.response?.status === 404) {
                commit('setIsSubscribed', false);
            } else {
                throw err;
            }
        }
    }
};

const mutations = {
    setIsSubscribed: (state, isSubscribed) => state.isSubscribed = isSubscribed,
};

export default {
    state,
    getters,
    actions,
    mutations,
}
